import { ICrop, selectMany } from "../omnia";

export function getMasterStyles(crops: ICrop[]) {
    type Style = ICrop["Style"];

    function getStyle(from: { Style?: Style; DefaultStyle?: Style }) {
        const s = from.DefaultStyle || from.Style;
        return {
            color: s?.Colour ?? null,
            pattern: s?.Pattern ?? null,
        };
    }

    function getMap<T>(from: T[], keySelector: (item: T) => number) {
        return new Map(from.map((a) => [keySelector(a), a]));
    }

    const cropStyles = crops.map((c) => ({
        cropId: c.CropId,
        varietyId: null,
        ...getStyle(c),
    }));

    const varietyStyles = selectMany(crops.map((c) => c.Varieties || [])).map((v) => ({
        cropId: v.CropId,
        varietyId: v.CropVarietyId,
        ...getStyle(v),
    }));

    const maps = {
        crops: getMap(cropStyles, (s) => s.cropId),
        varieties: getMap(varietyStyles, (v) => v.varietyId),
    };

    return {
        getCrop(cropId: number) {
            return maps.crops.get(cropId);
        },

        getVariety(varietyId: number) {
            return maps.varieties.get(varietyId);
        },
    };
}
